import { Component, h, Prop } from "@stencil/core"

/**
 * The component containing ready to go spinner.
 */
@Component({
  tag: "loading-spinner",
  styleUrl: "LoadingSpinner.scss",
})
export class LoadingSpinner {
  /**
   * Value displayed below the spinner.
   *
   * @default undefine
   */
  @Prop() loadingText?: string

  /**
   * Value if the spinner should be black.
   *
   * @default false
   */
  @Prop() isBlack?: boolean

  /**
   * The diameter of the spinner.
   *
   * @default 20px
   */
  @Prop() diameter?: string

  render() {
    return (
      <div class="spinnerDiv">
        <svg
          class="spinner"
          width={this.diameter ? this.diameter : "20px"}
          height={this.diameter ? this.diameter : "20px"}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <circle
            class={`path ${this.isBlack ? "strokeBlack" : ""}`}
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            cx="10"
            cy="10"
            r="8"></circle>
        </svg>
        {this.loadingText}
      </div>
    )
  }
}
